import { getUploadToken } from 'api/menuMapping/items'
import { BlobServiceClient } from '@azure/storage-blob'
import { toast } from 'react-toastify'

interface AzureUploadResult {
  success: boolean
  imageUrl?: string
  error?: string
}

/**
 * Uploads a file to Azure Blob Storage using SAS token
 * @param file - The file to upload
 * @param partnerId - The partner ID for authentication
 * @param containerName - The container name (default: 'menu-images')
 * @returns Promise<AzureUploadResult>
 */
export const uploadToAzure = async (
  file: File,
  partnerId: string,
  containerName = process.env.REACT_APP_ENV || 'assets'
): Promise<AzureUploadResult> => {
  try {
    // Get upload token (SAS token) from the API
    const uploadTokenResponse = await getUploadToken(partnerId, file.name, containerName)
    const { sas, file_name } = uploadTokenResponse.data.attributes

    // Use Azure SDK with SAS token
    const storageAccount = process.env.REACT_APP_AZURE_MENU_STORAGE_ACCOUNT || 'chowlymenuassets'
    const sasUrl = `https://${storageAccount}.blob.core.windows.net/?${sas}`

    // Create BlobServiceClient using SAS URL
    const blobServiceClient = new BlobServiceClient(sasUrl)
    const containerClient = blobServiceClient.getContainerClient(containerName)
    const blockBlobClient = containerClient.getBlockBlobClient(file_name)

    // Upload the file using Azure SDK
    await blockBlobClient.uploadData(file, {
      blobHTTPHeaders: {
        blobContentType: file.type
      }
    })

    // Return the final URL (without SAS token) - use the exact file_name from the API response
    // We encode the file_name again to prevent the backend from incorrectly decoding it by using ImageResizer.decode_url
    const encodedFileName = encodeURIComponent(file_name)
    const finalImageUrl = `https://${storageAccount}.blob.core.windows.net/${containerName}/${encodedFileName}`

    return {
      success: true, 
      imageUrl: finalImageUrl
    }
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred'
    toast.error(`Failed to upload image: ${errorMessage}`)
    return {
      success: false,
      error: errorMessage
    }
  }
}




